var map = {
	"./about-us": 3827,
	"./about-us.json": 3827,
	"./development": 4564,
	"./development.json": 4564,
	"./footer-logo": 5228,
	"./footer-logo.json": 5228,
	"./home-arrow": 2936,
	"./home-arrow.json": 2936,
	"./home-hello": 6405,
	"./home-hello.json": 6405,
	"./home-left-intro": 7389,
	"./home-left-intro.json": 7389,
	"./home-page_lottie-animation_about-us.png": 3237,
	"./home-right-intro_1": 2556,
	"./home-right-intro_1.json": 2556,
	"./hosting": 2175,
	"./hosting.json": 2175
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8180;